<template>
	<div class="black main-content-padding">
		<Panel :content-padding-top="0">
			<platform-tab @change="platformTabClick" :platformId="platformId"></platform-tab>
			<Search ref="search" @onSubmit="onSubmit" :platformId="platformId" />
		</Panel>
		<Panel>
			<div class="flex-row-align-center flex-just-between">
				<div class="flex-row-align-center">
					<el-checkbox @change="checkeFun" v-model="allChecked" class="ml-12 font-h4-regular yx-color-text-regular">当页全选</el-checkbox>
					<el-button @click="batchTranslate" class="ml-12" v-auth="['blacklist-anchor:unblock']">批量恢复</el-button>
				</div>
				<export-list
					v-if="$auth.hasPermi('blacklist-anchor:export')"
					ref="exportList"
					class="ml-12"
					:routerPath="routerPath"
					:platformId="platformId"
					:exportInterface="exportInterface"
				></export-list>
			</div>
			<multi-table
				class="mt-12 hoverClass"
				ref="multiTable"
				:list="tableList"
				:total="total"
				:columns="columns"
				:selectionChange="selectionChange"
				:options="{ selectable: true }"
				@gePartnerList="gePartnerList"
				:page="pageInfo"
			>
				<template v-slot:empty>
					<div class="empty-page">
						<div class="i-empty-customer"></div>
						<div class="font-h3-regular">暂无达人数据</div>
					</div>
				</template>
			</multi-table>
		</Panel>

		<!-- 恢复弹框 -->
		<translateDialog ref="translateDialog" @refresh="getList" :platformId="platformId" />

		<detail-drawer ref="detailDrawer" @getList="getList" :activeTab="'3'" />
	</div>
</template>
<script>
import { platformMixin } from '@rd/rd-ui';
import Search from './components/search';
import { dyColumns, ksColumns, spColumns } from './column';
import translateDialog from './components/translateDialog';
import { blacklist, blacklistExport } from '@/api/talentCRM';
import exportList from '@/views/common/exportList';
import detailDrawer from '../components/detailDrawer';
export default {
	components: {
		Search,
		translateDialog,
		exportList,
		detailDrawer,
	},
	mixins: [platformMixin],
	provide() {
		return {
			showDetailDrawer: row => this.showdetailDrawer(row.anchor_id),
		};
	},
	computed: {
		columns({ platformId }) {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: dyColumns,
				[dataMap.PLATFORM_KS.value]: ksColumns,
				[dataMap.PLATFORM_SP.value]: spColumns,
			};
			return temPF[platformId];
		},
		selectLen() {
			return this.selectionTalent.length;
		},
	},
	data() {
		return {
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			tableList: [],
			total: 0,
			params: {},
			tableParams: {},
			allChecked: false,
			selectionTalent: [],
			routerPath: '/talentCRM/record',
		};
	},
	created() {
		this.getList();
	},
	methods: {
		async getList() {
			const { list = [], page = {} } = await blacklist({ platformId: this.platformId, ...this.params, ...this.pageInfo, ...this.tableParams });
			const data = list.map(item => ({
				...item,
				operations: this.getButtons(item),
			}));
			this.tableList = Object.freeze(data);
			this.total = page.item_total || 0;
		},
		platformTabClick(val) {
			this.platformId = val;
			this.pageInfo.page_index = 1;
			this.params = {};
			this.$refs.search.onClear();
		},
		gePartnerList(val) {
			this.pageInfo.page_index = val.page_index;
			this.pageInfo.page_size = val.page_size;
			this.getList();
		},
		//选择商品
		selectionChange(val = []) {
			this.selectionTalent = val;
			this.allChecked = this.selectLen && this.selectLen === this.tableList?.length;
		},
		//选中值
		checkeFun(e) {
			this.$refs.multiTable.toggleSelection(this.tableList, e);
		},
		getButtons() {
			const arr = [];
			arr.push({
				label: '恢复',
				type: 'text',
				isShow: this.$auth.hasPermi('blacklist-anchor:unblock'),
				classtype: 2,
				click: row => {
					this.$refs.translateDialog.show('single', row);
				},
			});
			let filterArr = arr.filter(item => item.isShow);
			return filterArr;
		},
		onSubmit(val) {
			this.params = val;
			this.pageInfo.page_index = 1;
			this.getList();
		},
		showdetailDrawer(anchor_id) {
			this.$refs.detailDrawer.show(anchor_id);
		},
		//批量恢复
		batchTranslate() {
			if (!this.selectionTalent.length) {
				this.$message.warning('请选择达人');
				return;
			}
			this.$refs.translateDialog.show('batch', this.selectionTalent);
		},
		// 导出勾选
		async exportInterface(that) {
			that.$refs.exportDialog.show(this.exportDialog);
		},
		async exportDialog() {
			const taIds = this.selectionTalent.map(item => item.ta_id).join(',');
			const { params, pageInfo, platformId, routerPath } = this;
			await blacklistExport({ ...params, ...pageInfo, platformId, taIds });
			const handLink = this.$router.resolve({
				path: routerPath,
				query: { platform_id: platformId },
			});
			window.open(handLink.href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.empty-page {
	margin-top: 60px;
	display: flex;
	flex-direction: column;
	align-items: center;

	.i-empty-customer {
		width: 240px;
		height: 240px;
	}
}
</style>
